import React, {useLayoutEffect, useRef, useState} from 'react';

import {Button, ChevronDownIcon, ChevronUpIcon} from '@kit';

import {cls} from '../../../../components/utils';
import {Markdown} from '../../../../components/utils/md';

import css from './master.module.css';

type Props = {
	/** описание в разметке сайта: длиннее пяти строк сворачивается под кнопку */
	text: string;
};

export const ClampedDescription: React.FC<Props> = ({text}) => {
	const [isOpen, setOpen] = useState(false);
	const [isOverflowing, setOverflowing] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const element = ref.current;
		if (!element || isOpen) return;
		const measure = () => setOverflowing(element.scrollHeight > element.clientHeight + 1);
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(element);
		return () => observer.disconnect();
	}, [text, isOpen]);

	return (
		<div className={css.description}>
			<div ref={ref} className={cls(!isOpen && css.descriptionClamped)}>
				<Markdown text={text} />
			</div>
			{(isOverflowing || isOpen) && (
				<Button
					link
					size="small"
					icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
					iconPosition="after"
					onClick={() => setOpen(!isOpen)}
				>
					{isOpen ? 'Свернуть' : 'Показать полностью'}
				</Button>
			)}
		</div>
	);
};
